<script>
    import dressing from "@intellectability/platform-common";
    import {ACTIONS} from "@intellectability/platform-common/constants";
    import {actionCheck, create_security_error} from "@intellectability/platform-common/utils";
    import {Col, Row} from "@sveltestrap/sveltestrap";
    import {FlexList, MessageOfTheDayModal, userSecurity} from "@intellectability/platform-common/sv";

    const hasAccess = actionCheck(userSecurity.userActions);
    const isLoggedIn = userSecurity.loggedIn;

    const {MESSAGE_LIST} = ACTIONS;

    let loading = $state(true);

    // flexlist data
    let messages = $state.raw([]);

    // filter options
    let globalSearch = $state(""); // use to search the full list

    // pagination
    let pagination = $state({
        show: true,
        page: 1,
        limit: 10,
        recordsFiltered: null,
        recordsTotal: null,
        pageLengthMenu: [10, 25, 50, 100, 500]
    });

    // sort
    let sort = $state({
        field: "date_time",
        order: "desc"
    });

    let columns = $derived([
        {
            name: "Date/Time",
            field: "date_time",
            sortedBy: sort.field === "date_time" ? sort.order : "",
            sortable: true
        },
        {
            name: "Sender",
            field: "sender",
            sortedBy: sort.field === "sender" ? sort.order : "",
            sortable: true
        },
        {
            name: "Message",
            field: "text",
            sortedBy: sort.field === "text" ? sort.order : "",
            sortable: true,
            cell: message
        }
    ]);

    $effect(function load() {
        if (isLoggedIn && !hasAccess(MESSAGE_LIST)) {
            const err = create_security_error("Messages.svelte", "Messages", MESSAGE_LIST);
            dressing.api.report_security_error(err).then(() => dressing.api.logout());
        }
        else {
            loading = false;
        }
    });

    $effect(function filter_list() {
        if (!loading) {
            const filter_query = {
                search: globalSearch || null
            };

            const sort_query = {
                sort: sort.field || null,
                order: sort.order || null
            };

            const page_query = {
                page: pagination.page || null,
                limit: pagination.limit || null
            };

            dressing.get("/messages", {
                params: Object.assign(filter_query, {...sort_query, ...page_query})
            }).then(({data: res}) => {
                const {success, data} = res;
                if (success === true) {
                    const {messages: m} = data;
                    if (Array.isArray(m)) {
                        messages = m;
                        pagination.recordsFiltered = data.recordsFiltered;
                        pagination.recordsTotal = data.recordsTotal;
                    }
                }
            });
        }
    });

</script>
<Row class="align-items-center">
    <Col>
        <h1>
            Messages
        </h1>
    </Col>
    <Col xs="auto">
        <MessageOfTheDayModal/>
    </Col>
</Row>

<FlexList
        loading={loading}
        onglobalsearch={(value)  => globalSearch = value}
        pagerConfig={pagination}
        onpagechange={(page) => pagination.page = page}
        onsort={(field, order) => {sort = {field, order};}}
        onpagelengthchange={(newLimit) => pagination.limit = newLimit}
        {columns}
        data={messages}
>
</FlexList>

{#snippet message(row = {}, field = "")}
    {@const markup = (typeof row === "object" && row?.[field]) || ""}
    {#if typeof markup === "string"}
        {@html markup}
    {/if}
{/snippet}